import Login from  './Login.vue';
import Lock from './Lock.vue';
import AccountDeletion from './AccountDeletion.vue';
import PrivacyPolicy from './PrivacyPolicy.vue';

export default{
	Login,
	Lock,
	AccountDeletion,
	PrivacyPolicy
}
